import type { Seconds } from '@lemonade-hq/ts-helpers';
import { themeVars } from '@lemonade-hq/uniclient-theme';
import type { MotionNodeOptions } from 'motion/react';
import { motion } from 'motion/react';

export const ICON_ANIMATION_DURATION: Seconds = 0.5;
export const ICON_ANIMATION_DELAY: Seconds = 0.3;

const commonAnimationProps: MotionNodeOptions = {
  animate: { pathLength: 1 },
  initial: { pathLength: 0 },
  transition: { type: 'spring', duration: ICON_ANIMATION_DURATION, delay: ICON_ANIMATION_DELAY },
};

export const AnimatedCheckmark: React.FC = () => (
  <motion.svg fill="none" height="7px" viewBox="0 0 8 7" width="8px" xmlns="http://www.w3.org/2000/svg">
    <motion.path
      d="M1.5 3.66229L3.25 5.5L6.5 1.5"
      stroke={themeVars.color.frameProgressMark}
      strokeDasharray="0 1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.28571"
      {...commonAnimationProps}
    />
  </motion.svg>
);

export const AnimatedExclamationMark: React.FC = () => (
  <motion.svg fill="none" height="9px" viewBox="0 0 2 9" width="2px" xmlns="http://www.w3.org/2000/svg">
    <motion.path
      d="M0.99961 0.722656C1.49667 0.722656 1.89961 1.1256 1.89961 1.62266V4.82266C1.89961 5.31971 1.49667 5.72266 0.99961 5.72266C0.502553 5.72266 0.0996099 5.31971 0.0996099 4.82266V1.62266C0.0996099 1.1256 0.502554 0.722656 0.99961 0.722656ZM0.0996094 7.5907L0.0996099 7.59959C0.0996437 8.09665 0.502615 8.49956 0.999671 8.49953C1.49673 8.4995 1.89964 8.09652 1.89961 7.59947L1.89961 7.59058C1.89958 7.09352 1.4966 6.69061 0.999548 6.69064C0.502492 6.69067 0.0995755 7.09365 0.0996094 7.5907Z"
      fill={themeVars.color.frameProgressMark}
      {...commonAnimationProps}
    />
  </motion.svg>
);
